import { inject, Service } from '@angular/core'
import type { Params, UrlTree } from '@angular/router'
import { PageNavigationService } from '../../../shared/services/page-navigation/page-navigation.service'

const AGENT_QUERY_KEYS = ['threadId', 'widgetAction', 'widgetInvocation']

/** Supplies agent routes and parameters to the shared page navigation. */
@Service()
export class AgentNavigationService {
  private readonly pages = inject(PageNavigationService)

  /**
   * Opens a chat above the current app page and retains its query parameters.
   * @param {Params} queryParams Parameters for the requested conversation or widget action.
   * @returns {Promise<boolean>} Completion of the navigation.
   */
  openChat(queryParams?: Params): Promise<boolean> {
    return this.pages.open(this.agentUrl('chat', queryParams), 'assistant')
  }

  /**
   * Builds an agent overlay URL, including for legacy direct links.
   * @param {'chat' | 'threads'} view Agent view to open.
   * @param {Params} queryParams Parameters for the requested agent view.
   * @returns {UrlTree} One agent outlet above an app route.
   */
  agentUrl(view: 'chat' | 'threads', queryParams: Params = {}): UrlTree {
    return this.pages.pageUrl(['assistant', view], '/my-tasks', queryParams, 'assistant', AGENT_QUERY_KEYS)
  }

  /** Removes only AI and its parameters, retaining the screens below it. */
  close(): void {
    this.pages.close('assistant', AGENT_QUERY_KEYS)
  }
}
